import { useContext, useEffect, useState } from "react"
import Explode from "../lib/audio/explosion.mp3"
// import Airdrop from "../lib/audio/airdrop.mp3"
import CashoutSound from "../lib/audio/cashout.mp3"
// import airdropSound from "../lib/audio/airdrop.mp3";
import useSound from "use-sound"
import { AppContext, ValueContext } from "../context/createContext"
import { handleBackgroundSFX } from "./playBackground"
import { handlePlayEngineSFX } from "./playEngine"
import { handleplayStellarSFX } from "./playStellar"
import { handlePlayEngineCountdownSFX } from "./playEngineCountdown"

const useMusic = (
  isLoading: boolean,
  isError: boolean,
  errorText: string,
  isJackpot: boolean
) => {
  const {
    auth: { player_id },
    roundUserUpdate,
    audio: { music, isMusicOff, isSoundOff, sound },
    jackpotState,
    airdrop,
  } = useContext(AppContext)

  const { roundupdate } = useContext(ValueContext)
  const { value, state } = roundupdate
  const [isClicked, setIsClicked] = useState<boolean>(false)
  // const [flyBy, setFlyby] = useState(false);
  const [disableSounds, setDisableSounds] = useState(false)
  const [whileSolar, setWhileSolar] = useState("before-solar")
  const planetAppears =
    (+value >= 1 && +value < 4.9) ||
    (+value >= 6 && +value < 20) ||
    (+value >= 26 && +value < 70) ||
    (+value >= 104 && +value < 200) ||
    (+value >= 404 && +value < 550) ||
    (+value >= 874 && +value < 950)

  const [cachoutSound] = useSound(CashoutSound, {
    volume: isSoundOff ? 0 : parseFloat(sound) / 100,
  })
  // const [airdropSFX] = useSound(airdropSound, {
  //   volume: isSoundOff ? 0 : parseFloat(sound) / 100,
  // });

  // useEffect(() => {
  //   setTimeout(() => {
  //     console.log('sound')
  //     airdropSFX();
  //   }, 5000);
  // }, []);

  const [explode] = useSound(Explode, {
    volume: isSoundOff
      ? 0
      : parseFloat(sound) / 100 > 0.2
      ? 0.2
      : parseFloat(sound) / 100,
  })

  handleBackgroundSFX(
    isMusicOff,
    music,
    isError,
    isLoading,
    whileSolar,
    disableSounds,
    errorText,
    jackpotState.state
  )
  handlePlayEngineSFX(
    isSoundOff,
    sound,
    isError,
    isLoading,
    state,
    disableSounds,
    errorText,
    isJackpot
  )

  handleplayStellarSFX(
    isMusicOff,
    // sound,
    music,
    isError,
    isLoading,
    state,
    disableSounds,
    errorText,
    isJackpot
  )
  handlePlayEngineCountdownSFX(
    isSoundOff,
    sound,
    isError,
    isLoading,
    roundupdate.starttimer,
    disableSounds,
    isJackpot
  )

  useEffect(() => {
    window.addEventListener("click", () => setIsClicked(true))
  }, [])

  useEffect(() => {
    if (!isLoading && !isError && state === 3 && !isJackpot) {
      !disableSounds && explode()
    }
  }, [isLoading, isError, state, disableSounds, isJackpot])

  useEffect(() => {
    if (
      roundUserUpdate.id === player_id &&
      roundUserUpdate.cashout > 0 &&
      !isJackpot
    ) {
      !disableSounds && cachoutSound()
    }
  }, [roundUserUpdate, disableSounds, isJackpot])

  useEffect(() => {
    if (+value <= 4200) {
      setWhileSolar("before-solar")
    } else if (+value > 4200) {
      setWhileSolar("after-solar")
    }
  }, [value])

  useEffect(() => {
    if (isError || errorText !== "") {
      setDisableSounds(true)
    }
  }, [isError, errorText])
}

export default useMusic
